module.exports = __webpack_public_path__ + "static/media/hero.1f9fd2a0.jpg";